import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql, compose } from 'react-apollo';

const ExternalBlogTagsQuery = gql`
  query getExternalBlogTags {
    externalBlogTags
  }
`;

interface IInputProps {
    children?: any;
}

interface IResponse {
    data: any;
}

class GetExternalBlogTagsQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
    public render() {
        const { externalBlogTags }: any = this.props;
        return this.props.children({ externalBlogTags });
    }
}
  
export default compose(
    graphql<any, IResponse>(ExternalBlogTagsQuery, {
      name: 'externalBlogTags',
      options: props => ({
        fetchPolicy: 'network-only'
      })
    }),
  )(GetExternalBlogTagsQuery);


// WEBPACK FOOTER //
// ./src/components/Query/ExternalBlog/ExternalBlogTags.ts